const styles = ({ breakpoints, dimensions, palette }) => ({
  root: {
    flexGrow: 1,
    overflow: 'hidden',
    left: dimensions.sidebarWidthCollapsed,
  },
  signUpDialogRoot: {
    zIndex: '9999 !important',
  },
  title: {
    textAlign: 'center',
  },
  type: {
    fontSize: 20,
    marginTop: 15,
    fontWeight: 500,
  },
  content: {
    overflow: 'hidden',
  },
  actions: {
    display: 'flex',
    marginBottom: 40,
    justifyContent: 'center',
  },

  close: {
    paddingTop: 12,
    display: 'flex',
    paddingRight: 12,
    justifyContent: 'flex-end',
  },
  scrollPaper: {
    maxHeight: 'none',
    [breakpoints.down('xs')]: {
      margin: 12,
    },
  },
  loader: {
    position: 'absolute',
    left: 0,
    right: 0,
    height: dimensions.smallLoaderHeight,
  },
  loaderContainer: {
    position: 'relative',
    width: '100%',
  },
  changePassword: {
    fill: palette.primary.main,
  },
  shiftRight: {
    left: dimensions.sidebarWidthExpanded,
  },
})

export default styles
